export default class SpreedlyException extends Error {
    constructor(public readonly paymentData: any) {
        super('There are some Spreedly errors from payment tokenization');
    }
}
